import { CommonSheet } from '../types'

export interface MassPayoutSheetMeta {}

export const MassPayoutActionIds = {
  MASSPAYOUTS: 'MASSPAYOUTS',
  MASSPAYOUTS_UPLOAD: 'MASSPAYOUTS_UPLOAD',
}

export type MassPayoutActionId = (typeof MassPayoutActionIds)[keyof typeof MassPayoutActionIds]

export interface MassPayoutActionSheet extends CommonSheet {
  actionId?: MassPayoutActionId
  meta?: MassPayoutSheetMeta
}
